module.exports = __webpack_public_path__ + "img/118D.a3cd7e91.png";